import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class CashBalanceApi {
    static async getCurrentBalance() {
        return instance.get('/cash_balance');
    }
    static async getDateBalance(date) {
        return instance.get('/cash_balance/' + date);
    }
    static async getLastBalance(){
        return instance.get('/last_balance');
    }
    static async initNewCashBalance(data){
        data.action = 'open'
        return instance.post('/cash_balance', data);
    }
    static async closeCashBalance(data){
        data.action = 'close'
        return instance.post('/cash_balance', data);
    }
    static async makeMovement(data){
        return instance.post('/cash_movement', data)
    }
    
}   






// WEBPACK FOOTER //
// ./src/api/cash_balance_api.js